import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import React from 'react'
import { ISidebarMenuItem, drawerWidth, routeUrls, sidebarMenuItems } from 'src/utils/constants'

import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'src/store'
import { handleDrawerToggle } from 'src/store/features/common/commonSlice'
import AppIcon from 'src/assets/images/AppIcon.png'
import { useNavigate } from 'react-router-dom'
import { isActiveLink } from 'src/utils/helpers'

import styles from './index.module.scss'
import { logoutUser } from 'src/store/features/auth/authActions'

interface SidebarProps {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window?: () => Window
}

const Sidebar = ({ window }: SidebarProps) => {
  const container = window !== undefined ? () => window().document.body : undefined
  const { mobileOpen } = useSelector((state: RootState) => state.common)
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()

  const handleNavigation = (item: ISidebarMenuItem) => {
    if (item.url === routeUrls.logout) {
      dispatch(logoutUser())
    } else {
      navigate(item.url)
    }
  }

  const drawer = (
    <div>
      <Box textAlign='center' pt={3} pb={3}>
        <img src={AppIcon} alt='AppIcon' />
      </Box>
      <List>
        {sidebarMenuItems.map((item, index) => (
          <ListItem key={item.label}>
            <ListItemButton
              sx={{
                color: 'white',
              }}
              onClick={() => handleNavigation(item)}
              className={isActiveLink(item.url) ? styles.activeNavItem : styles.inActiveNavItem}
            >
              <ListItemIcon> {item.icon} </ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  )

  return (
    <Box
      component='nav'
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      aria-label='mailbox folders'
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        container={container}
        variant='temporary'
        open={mobileOpen}
        onClose={() => dispatch(handleDrawerToggle())}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            background: '#111111',
            '&::-webkit-scrollbar': {
              width: '0.3em',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'red',
              borderRadius: '3px',
            },
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant='permanent'
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            background: '#111111',
            '&::-webkit-scrollbar': {
              width: '0.3em',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'red',
              borderRadius: '3px',
            },
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  )
}

export default Sidebar
